import { Box } from '@hopin-team/ui-box';
import { Text } from '@hopin-team/ui-text';
import { Toast } from '@hopin-team/ui-toast';
import { rem } from 'polished';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const StyledToast = styled(Toast)`
  background-color: #fff2f2;
  height: ${rem(56)};
`;

export const ErrorToast = ({ title, subtitle }) => {
  return (
    <StyledToast icon="alert" role="status" iconColor="red-600">
      <Box mr={2}>
        {title && (
          <Text pattern="strong" color="gray-400">
            {title}
          </Text>
        )}{' '}
        {subtitle && (
          <Text pattern="body" color="gray-400">
            {subtitle}
          </Text>
        )}
      </Box>
    </StyledToast>
  );
};

ErrorToast.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};
